










import Component from 'vue-class-component'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {Action} from 'vuex-class'
import {Prop} from 'vue-property-decorator'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'

@Component
export default class ReportsTabComponent extends AfterFetchComponent {

    @Action('getEmployeeReports', StoreNamespace.CUSTOMER_SERVICE) getEmployeeReports: any
    @Action('generateEmployeeReport', StoreNamespace.CUSTOMER_SERVICE) generateEmployeeReport: any

    @Prop() memberIdNum!: string

    private columns: GridColumn[] = []

    beforeMount() {
        this.hasFeedback = true
    }

    mounted() {
        this.initColumns();
        this.getEmployeeReports({
            requestorCallback: this,
            requestBody: {
                pageNumber: 0,
                pageSize: 10
            }
        })
    }

    private initColumns(): void {
        this.columns.push({property: 'reportTitle', header: 'file_name'} as GridColumn)
        this.columns.push({property: 'reportDescription', header: 'file_desc'} as GridColumn)

        this.columns.forEach((column: GridColumn) => column.hideSorting = true)
    }

    onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
        if (requestName === 'findMembersOrEmployersFor/getEmployeeReports') {
            this.$emit('successResults', data)
        } else {
            this.$emit('successExport', data)
        }
    }

    onExportClick(data: any) {
        this.generateEmployeeReport({
            requestorCallback: this,
            requestBody: {
                fileType: data.selectedFileType,
                reportTypeCode: data.id,
                idNumber: this.memberIdNum
            }
        })
    }
}

